import http from './http';
import {PROJECT_BASE} from './paths';
import {withPerm} from './perm';

const BASE_URL = PROJECT_BASE;

// 프로젝트 목록 조회 (내 프로젝트)
export const getProjectList = withPerm(async () => {
  const response = await http.get(`${BASE_URL}/my`);
  return response.data;
}, 'GET', `${BASE_URL}/my`);

// 프로젝트 단건 조회
export const getProject = withPerm(async (pjtId) => {
  const response = await http.get(`${BASE_URL}/${pjtId}`);
  return response.data;
}, 'GET', `${BASE_URL}/{pjtId}`);

// 프로젝트 검색
export const searchProject = withPerm(async (params) => {
  const response = await http.get(`${BASE_URL}/search`, { params });
  return response.data;
}, 'GET', `${BASE_URL}/search`);

// 프로젝트 생성
export const createProject = withPerm(async (payload) => {
  const response = await http.post(`${BASE_URL}`, payload, {
    headers: { 'Content-Type': 'application/json' },
  });
  return response.data;
}, 'POST', `${BASE_URL}`);

// 프로젝트 수정
export const updateProject = withPerm(async (pjtId, payload) => {
  const response = await http.patch(`${BASE_URL}/${pjtId}`, payload, {
    headers: { 'Content-Type': 'application/json' },
  });
  return response.data;
}, 'PATCH', `${BASE_URL}/{pjtId}`);

// 프로젝트 삭제
export const deleteProject = withPerm(async (pjtId) => {
  const response = await http.delete(`${BASE_URL}/${pjtId}`);
  return response.data;
}, 'DELETE', `${BASE_URL}/{pjtId}`);
